import { collections } from "@/mocks/homeData";

export default function CollectionRail() {
  return (
    <section id="collections" className="px-4 md:px-8 py-10 border-t border-background-200/60">
      <div className="flex items-end justify-between mb-6">
        <div>
          <p className="text-xs tracking-[0.3em] text-secondary-600 font-label mb-2">COLLECTIONS</p>
          <h2 className="font-heading text-xl md:text-3xl font-black text-foreground-950">今日精选合集</h2>
        </div>
        <p className="hidden md:block text-sm text-foreground-500">按更新速度排序 · 共 6 个合集</p>
      </div>

      <div className="flex gap-5 overflow-x-auto pb-3 -mx-4 px-4 md:mx-0 md:px-0 snap-x no-scrollbar">
        {collections.map((item, idx) => (
          <a
            href="#videos"
            key={item.title}
            className="group shrink-0 w-[210px] md:w-[240px] snap-start cursor-pointer"
          >
            <div className="relative w-full h-[280px] md:h-[320px] rounded-lg overflow-hidden bg-background-100">
              <img
                src={item.image}
                alt={item.title}
                title={`${item.title} 91网合集`}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-background-50/90 text-foreground-900 text-xs font-medium">
                NO.{String(idx + 1).padStart(2, "0")}
              </span>
              <span className="absolute bottom-3 left-3 right-3 inline-flex items-center gap-1.5 text-white text-xs">
                <i className="ri-stack-line" /> {item.count}
              </span>
            </div>
            <h3 className="mt-3 font-heading text-base font-bold text-foreground-950 line-clamp-1 group-hover:text-primary-600">
              {item.title}
            </h3>
            <p className="mt-1 text-xs text-foreground-500 line-clamp-2">{item.desc}</p>
          </a>
        ))}
      </div>
    </section>
  );
}